import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Ticker } from '../components/Ticker';
import { Mission } from '../components/Mission';
import { UseCases } from '../components/UseCases';
import { Materials } from '../components/Materials';
import { Product } from '../components/Product';
import { WhatsInBox } from '../components/WhatsInBox';
import { SocialProof } from '../components/SocialProof';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingElements } from '../components/FloatingElements';
import { ClassifiedProject } from '../components/ClassifiedProject';
import { AsSeenIn } from '../components/AsSeenIn';
export const Home = () => {
  return <div className="relative" data-id="element-1615">
      <TopBar data-id="element-1616" />
      <Navigation data-id="element-1617" />

      <main data-id="element-1618">
        <Hero data-id="element-1619" />
        <Ticker data-id="element-1620" />
        <Mission data-id="element-1621" />
        <AsSeenIn data-id="element-1622" />
        <UseCases data-id="element-1623" />
        <WhatsInBox data-id="element-1624" />
        <Materials data-id="element-1625" />
        <Product data-id="element-1626" />
        <Guarantee data-id="element-1627" />
        <FAQ data-id="element-1628" />
        <ClassifiedProject data-id="element-1629" />
        <SocialProof data-id="element-1630" />
        <Contact data-id="element-1631" />
      </main>

      <Footer data-id="element-1632" />
      <FloatingElements data-id="element-1633" />
    </div>;
};